import React, { FC } from 'react';
import { Button } from '@components/Common';
import { useTranslation } from 'react-i18next';
import { StoreFiltersConfig } from '../../../configs';
import { useStoreMultiFilter } from '../../../hooks';
import { Container } from './filter-modal.style';
import { IDialogComponent } from 'core/interfaces';

interface IMultiFilterDialog extends IDialogComponent<string[]> {}

export const MultiFilterDialog: FC<IMultiFilterDialog> = ({ handleCloseModal, data }) => {
  const { t } = useTranslation('marketplace');
  const [key] = data;
  const { changeDetailed, values } = useStoreMultiFilter<any>(key);
  const hasSelection = Array.isArray(values) && values.length > 0;

  return (
    <Container>
      <div className="filter-title">{Array.isArray(data) && <>{t(`${key}.label`)}</>}</div>
      <div className="filter-list">
        {Array.from(StoreFiltersConfig.detailed(key).entries()).map(([k, v]) => {
          const selected = values?.includes(k) || false;
          return (
            <button key={k} className="filter-list-item" onClick={changeDetailed(k, selected)}>
              <div>
                <span className={`indicator ${selected ? 'selected' : ''}`} />
              </div>
              <div className="description">
                <span>{t(`${key}.${v}`)}</span>
              </div>
            </button>
          );
        })}
        <div className={`item-buffer ${hasSelection ? 'visible' : ''}`} />
        <div
          className={`filter-controller ${hasSelection ? 'visible' : ''}`}
          onClick={handleCloseModal}
        >
          <Button className="primary full" onClick={handleCloseModal}>
            {t('show selected')}
          </Button>
        </div>
      </div>
    </Container>
  );
};
